import React from 'react';
import styles from './Button.module.scss';
import className from 'classnames/bind';
import Link from 'next/link';
import checkForExternalLink from '@/helpers/checkForExternalLink';

let cx = className.bind(styles);

export function Button({ href, children, className, outlined = false, wordressPageInNav, target, ...props }) {
	const classNameArray = className?.split(' ') || [];
	const elem = wordressPageInNav || (wordressPageInNav === undefined && !checkForExternalLink(href)) ? Link : 'a';
  let innerHtml, reactChildren;
  typeof children === 'string' ? innerHtml = { __html: children ?? '' }: reactChildren = children ;
  
	return React.createElement(elem, {
		href: href ?? '',
		className: cx(['ns_button', 'button', 'link-button', outlined && 'is-style-outline', ...classNameArray]),
		dangerouslySetInnerHTML: innerHtml,
    target: target,
    rel: target === '_blank' ? 'roreferrer noopener' : null,
    ...props
	}, reactChildren);
}
